<template>
  <div id="app" data-component="mobile-app" class="mobile-app">
    <!-- -----  application header ------------- -->
    <app-header v-if="!showCaseReadOnly" />
    <notifications />
    <!-- -----  application main ------------- -->
    <!-- <error-boundary> -->
    <router-view />
    <!-- </error-boundary> -->
  </div>
</template>

<script>
//---- components ---------
import AppHeader from "./components/callcenter/app-header/Header.vue";
import Notifications from "./components/callcenter/app-header/Notifications.vue";
// import ErrorBoundary from "./components/shared/errors/error-boundary.vue";

export default {
  components: {
    AppHeader,
    Notifications,
    // ErrorBoundary,
  },
  computed: {
    showCaseReadOnly() {
      return this.$store.state.projectData.showCaseReadOnly;
    },
  },
};
</script>

<style scoped>
.mobile-app {
  /* full screen */
  width: 100vw;
  height: 100%;

  display: flex;
  flex-direction: column;
}
/* .app >>> header {

  } */
</style>